/**
 * 二级 Guide / Help 页追加段落（按 path 合并进 CORE_SUB_PAGES.sections）
 */
export const SUB_PAGE_EXTRAS = {
	'/features/customization/': [
		{
			h2: 'Quick checklist before sharing screenshots',
			paragraphs: [
				'If you post themed chat screenshots online, blur contact names and profile photos. Theme packs do not remove personal data from the image you capture.',
			],
			list: [
				'Note theme file source if you import community packs',
				'Revert to default theme before sending device logs to support forums',
				'Test voice-message screen and call screen—some themes skip those views',
			],
		},
	],
	'/features/media-sharing/': [
		{
			h2: 'Recording voice notes and large audio',
			paragraphs: [
				'Voice notes follow the same upload path as video. Long recordings fail on weak networks; pause and retry on Wi‑Fi instead of sending duplicate clips.',
			],
		},
	],
	'/features/chat-features/': [
		{
			h2: 'DND and quiet hours',
			paragraphs: [
				'In-app DND modes pause alerts without turning off system notifications for other apps. Pair DND with auto-reply so contacts know you are not ignoring them manually.',
			],
		},
	],
	'/features/privacy-features/': [
		{
			h2: 'Compare with official WhatsApp',
			paragraphs: [
				'Official WhatsApp now includes last seen, read receipts, Chat Lock, and disappearing messages. List what you truly need from a mod before accepting sideload risk—many privacy goals no longer require an unofficial APK.',
			],
		},
	],
	'/installation/backup-chats/': [
		{
			h2: 'Google Drive vs local backup',
			paragraphs: [
				'Cloud backups depend on the Google account signed into the phone. Local backups may live under internal storage paths that uninstallers delete—copy important .db files to a PC when migrating between APK lines.',
			],
			list: [
				'Note backup time and size after each run',
				'Avoid starting a backup on mobile data if media is large',
				'Disable battery saver during long backup jobs',
			],
		},
		{
			h2: 'Before switching APK sources',
			paragraphs: [
				'Backups from one mod line may not restore on another. If you change publishers, plan for partial chat loss and export important threads manually.',
			],
		},
	],
	'/installation/restore-chats/': [
		{
			h2: 'Restore timing',
			paragraphs: [
				'Restoration usually runs once after SMS verification. Interrupting the process can corrupt media downloads—keep the phone on power and Wi‑Fi until counts match expectations.',
			],
		},
		{
			h2: 'Partial restore symptoms',
			paragraphs: [
				'Missing groups often mean the backup predates membership changes. Missing media may still download if you tap into chats and wait on Wi‑Fi.',
			],
		},
	],
	'/installation/without-uninstalling/': [
		{
			h2: 'Two icons on the home screen',
			paragraphs: [
				'Dual installs use different package names. Notifications, badges, and default share targets may only attach to one app—pick which client you want for daily use.',
			],
		},
		{
			h2: 'Verification on two apps',
			paragraphs: [
				'One phone number typically registers on one WhatsApp client at a time. Dual-app marketing does not always mean two active numbers on one SIM—read your APK publisher notes carefully.',
			],
		},
	],
	'/installation/android/': [
		{
			h2: 'Play Protect and OEM warnings',
			paragraphs: [
				'Android may warn about unknown apps even for legitimate sideloads. Read the full dialog; “Install anyway” is your choice after reviewing source trust. Samsung and Xiaomi may add extra scans—wait for them to finish.',
			],
		},
		{
			h2: 'First-run checklist',
			list: [
				'Confirm notification permission',
				'Allow contacts if you want to find friends',
				'Set media auto-download on Wi‑Fi only if data is limited',
				'Open Settings → GB Settings and note your version string',
			],
		},
	],
	'/update/without-losing-chats/': [
		{
			h2: 'When “Update” is not offered',
			paragraphs: [
				'Android shows Update only when package signatures match. A different publisher APK may force a clean install—never uninstall until backups are verified on storage or another device.',
			],
		},
		{
			h2: 'Rollback planning',
			paragraphs: [
				'Keep the previous APK file if the new build crashes on your phone. Install the older file over the new one only when signatures allow; otherwise restore from backup after reinstall.',
			],
		},
	],
	'/update/check-version/': [
		{
			h2: 'Marketing version vs build number',
			paragraphs: [
				'Labels like v18.80 describe marketing lines; filenames may include build numbers. Match both to our <a href="/download/">download page</a> to avoid downloading the wrong branch.',
			],
		},
		{
			h2: 'Version history context',
			paragraphs: [
				'Older builds exist for compatibility with legacy phones. Installing an old APK for stability can expose you to unfixed bugs—prefer recent verified builds when your Android version allows.',
			],
		},
	],
	'/update/update-failed/': [
		{
			h2: 'Signature mismatch errors',
			paragraphs: [
				'“App not installed” after an update often means the new APK was signed by a different key. You cannot upgrade in place—you must backup, uninstall, and install the new package, then restore.',
			],
		},
		{
			h2: 'Storage and cache during failed installs',
			paragraphs: [
				'Failed installs sometimes leave partial packages. Clear the Downloads folder, reboot, and ensure at least 1 GB free before retrying.',
			],
		},
	],
	'/safety/privacy-risks/': [
		{
			h2: 'Permissions worth reviewing',
			paragraphs: [
				'After install, open Android Settings → Apps → GB WhatsApp Pro → Permissions. Question access to SMS, phone, or accessibility services unless you understand why the mod requests them.',
			],
			list: [
				'Contacts and microphone for normal chat use',
				'Storage or media access for backups and downloads',
				'Overlay or accessibility only if you knowingly enabled mod extras',
			],
		},
		{
			h2: 'Backups and cloud exposure',
			paragraphs: [
				'Google Drive backups for mods are not managed by Meta the same way as official WhatsApp. Treat cloud copies as sensitive data and use a Google account you control.',
			],
		},
		{
			h2: 'Network and metadata',
			paragraphs: [
				'End-to-end encryption claims for unofficial builds are difficult to verify independently. Assume metadata (who you talk to, when, IP addresses at connection time) may be visible to infrastructure you do not control.',
			],
		},
		{
			h2: 'Further reading',
			paragraphs: [
				'Read <a href="/is-gb-whatsapp-safe/">Is GB WhatsApp safe?</a>, <a href="/safety/malware-and-fake-apks/">fake APKs</a>, and <a href="/safety/account-ban-risk/">account ban risk</a> before trusting sensitive chats to a mod.',
			],
		},
	],
	'/safety/account-ban-risk/': [
		{
			h2: 'Official policy context',
			paragraphs: [
				'WhatsApp Help Center articles describe unsupported apps and may instruct users to install official WhatsApp. GBWhatPro.org summarizes those expectations but does not speak for Meta—always read the message on your device first.',
			],
		},
		{
			h2: 'Temporary vs permanent restrictions',
			paragraphs: [
				'Temporary limits may show countdown timers or ask you to use official WhatsApp. Permanent loss means you must register a new number or appeal through official channels—mods cannot reverse Meta decisions.',
			],
		},
		{
			h2: 'Behaviors that add risk beyond using a mod',
			list: [
				'Bulk unsolicited messaging or scraped contact lists',
				'Automated forwarding chains and broadcast spam',
				'Using multiple unofficial clients on one number in short succession',
			],
		},
		{
			h2: 'If you depend on this number',
			paragraphs: [
				'Migrate critical contacts to official WhatsApp with a verified backup plan. See <a href="/switch-from-gb-whatsapp-to-official-whatsapp/">switching to official WhatsApp</a> for limits.',
			],
		},
	],
	'/safety/malware-and-fake-apks/': [
		{
			h2: 'Compare file size and publisher',
			paragraphs: [
				'A file much smaller than the verified build on <a href="/download/">download</a> is a red flag. Compare SHA-style notes when published; at minimum match megabyte size on the same network.',
			],
		},
		{
			h2: 'Where fake APKs spread',
			list: [
				'Telegram channels with re-uploaded files',
				'YouTube description links that change daily',
				'Search ads that mimic official branding',
			],
		},
		{
			h2: 'If you already installed an unknown APK',
			paragraphs: [
				'Uninstall after backup if possible, change passwords for accounts accessed on the device, and run a scan with your preferred Android security tool. Consider factory reset for high-risk sideloads.',
			],
		},
	],
	'/help/not-installing/': [
		{
			h2: 'Manufacturer-specific blocks',
			paragraphs: [
				'Huawei, Honor, and some enterprise devices restrict unknown sources further. Install from Files app after granting permission to that app specifically, not only the browser.',
			],
		},
		{
			h2: 'When to stop retrying random APKs',
			paragraphs: [
				'If three verified downloads fail the same way, capture the exact error text and Android version before trying unrelated mirrors—see <a href="/safety/malware-and-fake-apks/">fake APK guidance</a>.',
			],
		},
	],
	'/help/not-opening/': [
		{
			h2: 'Safe mode test',
			paragraphs: [
				'Boot Android into safe mode to disable third-party overlays. If GB WhatsApp Pro opens in safe mode, a screen recorder or bubble app may conflict—remove suspects one by one.',
			],
		},
	],
	'/help/keeps-crashing/': [
		{
			h2: 'Android WebView and system updates',
			paragraphs: [
				'Update Android System WebView and Google Play services from Play Store. Crashes right after a system update often clear after WebView patches arrive.',
			],
		},
	],
	'/help/messages-not-sending/': [
		{
			h2: 'VPN and DNS filters',
			paragraphs: [
				'Disable VPN, ad blockers, and private DNS temporarily. Corporate Wi‑Fi may block WhatsApp endpoints—test on mobile data.',
			],
		},
	],
	'/help/messages-not-receiving/': [
		{
			h2: 'Dual app / second space clones',
			paragraphs: [
				'Cloned apps on Xiaomi, Oppo, or Samsung may not receive push reliably. Install the primary copy in the main profile when possible.',
			],
		},
	],
	'/help/photos-videos-not-downloading/': [
		{
			h2: 'Auto-download settings',
			paragraphs: [
				'Check GB Settings → Storage and data. Set videos to Wi‑Fi only, then open the chat on Wi‑Fi and tap the media bubble to retry.',
			],
		},
	],
	'/help/notifications-not-working/': [
		{
			h2: 'Channel-level toggles (Android 8+)',
			paragraphs: [
				'Long-press a notification → settings, or open App info → Notifications and enable all GB WhatsApp Pro categories, not just the master switch.',
			],
		},
	],
	'/help/verification-code-not-received/': [
		{
			h2: 'SIM and roaming',
			paragraphs: [
				'Roaming SIMs may delay SMS. Insert the SIM in a basic phone to confirm SMS works, then return it before requesting a new code.',
			],
		},
	],
	'/help/storage-problems/': [
		{
			h2: 'WhatsApp media folder cleanup order',
			steps: [
				'Back up chats first',
				'Delete large videos you already saved elsewhere',
				'Clear cache (not data) inside app settings',
				'Retry install or media download',
			],
		},
	],
}
